import styled from 'styled-components'
import { Meta } from '~/components/typography'

export const StyledMeta = styled(Meta)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
})
